<template lang="pug">
#modal-editar-cadastrar-representante
    el-dialog(
        width='400px',
        :title='`${editar ? $t("mensagens.comuns.editar") : $t("mensagens.comuns.cadastrar")} ${$t("mensagens.pessoas.pessoa")}`',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        .scroll-wrapper
            el-form(
                :model='formulario',
                ref='formulario',
                label-position='top'
            )
                .form-secao(
                    v-for='secaoItem in secoesFormulario',
                    :key='secaoItem.key'
                )
                    h4.form-secao__titulo {{ $t(secaoItem.label) }}
                    .form-secao__grid
                        el-form-item(
                            v-for='item in secaoItem.campos',
                            :label='$t(item.label)',
                            :key='item.key',
                            :class='{ "form-secao__campo--full": item.fullWidth }',
                            :prop='"form." + formulario.form.indexOf(item) + ".value"',
                            :rules='item.rules'
                        )
                            component(
                                v-if='!item.bind.mask',
                                :is='item.component',
                                v-model='item.value',
                                v-bind='item.bind',
                                style='width: 100%',
                                :placeholder='$t(item.bind.placeholder)',
                                @change='updateCity(item.key)'
                            )
                                el-option(
                                    v-for='tipo in item.options',
                                    :key='tipo.code',
                                    :label='tipo.label',
                                    :value='tipo.code'
                                )
                            component(
                                v-else,
                                :is='item.component',
                                v-model='item.value',
                                v-bind='item.bind',
                                v-mask='inputMask[item.key]',
                                :placeholder='$t(item.bind.placeholder)',
                                @change='updateCity(item.key)',
                                @input='updateMask(item)'
                            )
                                el-option(
                                    v-for='tipo in item.options',
                                    :key='tipo.code',
                                    :label='tipo.label',
                                    :value='tipo.code'
                                )
            footer.espaco(slot='footer')
                el-button(type='default', @click='fechar')
                    | {{
                    | $t("mensagens.comuns.cancelar")
                    | }}
                el-button(type='primary', @click='salvar("formulario")')
                    | {{
                    | $t("mensagens.comuns.salvar")
                    | }}
    modal-atalho-territorio(
        :isSucursal='isSucursal',
        :mostrar='mostrarModalRedirecionamentoTerritorio',
        @fechar='fecharModalAtalhoTerritorio'
    )
</template>

<script>
import RepresentanteService from '@/services/RepresentanteService';
import LocalidadeService from '@/services/LocalidadeService';

import formatters from '@/utils/formatters';
import validators from '@/utils/validations/validators';
import { ParaguayRUCValidator } from '@/utils/validations/ruc';
import { validateCuit } from '@/utils/validations/cuit';
import ModalAtalhoTerritorio from '@/components/ModalAtalhoTerritorio';
import { mapActions, mapGetters } from 'vuex';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import SucursaleService from '@/services/SucursaleService';

export default {
    name: 'ModalEditarCadastrarRepresentante',
    components: {
        ModalAtalhoTerritorio
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        isSucursal: {
            type: Boolean,
            required: false,
            default: false
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dadosRepresentante: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        const validationDocument = (_, value, callback) => {
            if (this.locale === 'py') {
                const validator = new ParaguayRUCValidator();
                if (!validator.validateRUC(value)) {
                    callback(this.$t('mensagens.pessoas.numeroRucErro'));
                } else {
                    callback();
                }
            } else if (this.locale === 'ar') {
                if (!validateCuit(value)) {
                    callback(this.$t('mensagens.pessoas.cuitErro'));
                } else {
                    callback();
                }
            } else {
                if (!validators.validarDocumento(value)) {
                    callback(this.$t('mensagens.pessoas.numeroCpfCnpjErro'));
                } else {
                    callback();
                }
            }
        };

        const validationName = (_, value, callback) => {
            if (value.trim().length < 3) {
                callback(
                    this.$t('mensagens.pessoas.digiteTresCaracteresParaSalvar')
                );
            } else {
                callback();
            }
        };

        return {
            inputMask: {
                documento: 'XXXXXXXXXXXXXXXXX',
                telefone: '###########'
            },
            mostrarModalRedirecionamentoTerritorio: false,
            ambientes: AmbientesEmpresas,
            paises: [
                { id: 1, code: 'BR', label: 'Brasil' },
                { id: 2, code: 'PY', label: 'Paraguai' },
                { id: 3, code: 'AR', label: 'Argentina' }
            ],
            form: {
                base: [
                    {
                        key: 'pais',
                        label: 'mensagens.comuns.pais',
                        component: 'el-input',
                        value: '',
                        section: 'identificacao',
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            class: 'w-full',
                            disabled: true,
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'nome',
                        label: 'mensagens.pessoas.nomeRazaoSocial',
                        component: 'el-input',
                        value: '',
                        section: 'identificacao',
                        fullWidth: true,
                        rules: [
                            {
                                required: true,
                                message: this.$t(
                                    'mensagens.comuns.campoObrigatorio'
                                ),
                                trigger: 'blur'
                            },
                            {
                                validator: validationName,
                                trigger: 'blur'
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.pessoas.nomeRazaoSocial'
                        }
                    },
                    {
                        key: 'documento',
                        label: 'mensagens.pessoas.documento',
                        component: 'el-input',
                        value: '',
                        section: 'identificacao',
                        rules: [
                            {
                                required: true,
                                message: this.$t(
                                    'mensagens.comuns.campoObrigatorio'
                                ),
                                trigger: 'blur'
                            },
                            {
                                validator: validationDocument,
                                trigger: 'blur'
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.pessoas.numeroCpfCnpj',
                            mask: true
                        }
                    }
                ],
                br: [
                    {
                        key: 'email',
                        label: 'mensagens.comuns.email',
                        component: 'el-input',
                        value: '',
                        section: 'contato',
                        fullWidth: true,
                        rules: [
                            {
                                type: 'email',
                                message: this.$t(
                                    'mensagens.pessoas.emailInvalido'
                                ),
                                trigger: ['blur', 'change']
                            },
                            {
                                message: this.$t(
                                    'mensagens.comuns.campoObrigatorio'
                                ),
                                trigger: ['blur', 'change']
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.comuns.email'
                        }
                    },
                    {
                        key: 'id',
                        label: this.isAlvorada
                            ? 'BP Pessoa'
                            : 'mensagens.operacao.formularioPessoa.idPessoa',
                        component: 'el-input',
                        value: '',
                        section: 'outros',
                        fullWidth: true,
                        bind: {
                            maxlength: 200,
                            placeholder: this.isAlvorada
                                ? 'BP Pessoa'
                                : 'mensagens.operacao.formularioPessoa.idPessoa'
                        }
                    }
                ],
                py: [
                    {
                        key: 'email',
                        label: 'mensagens.comuns.email',
                        component: 'el-input',
                        value: '',
                        section: 'contato',
                        rules: [
                            {
                                type: 'email',
                                message: this.$t(
                                    'mensagens.pessoas.emailInvalido'
                                ),
                                trigger: ['blur', 'change']
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.comuns.email'
                        }
                    },
                    {
                        key: 'telefone',
                        label: 'mensagens.pessoas.telefone',
                        component: 'el-input',
                        value: '',
                        section: 'contato',
                        bind: {
                            placeholder: 'mensagens.comuns.telefone',
                            mask: true
                        }
                    },

                    {
                        key: 'endereco',
                        label: 'mensagens.pessoas.endereco',
                        component: 'el-input',
                        value: '',
                        section: 'localizacao',
                        fullWidth: true,
                        bind: {
                            placeholder: 'mensagens.pessoas.endereco'
                        }
                    },
                    {
                        key: 'estado',
                        label: 'mensagens.pessoas.departamento',
                        component: 'el-select',
                        value: '',
                        options: [],
                        section: 'localizacao',
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.departamento',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'municipio',
                        label: 'mensagens.pessoas.distrito',
                        component: 'el-select',
                        value: '',
                        options: [],
                        section: 'localizacao',
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.distrito',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'id',
                        label: this.isAlvorada
                            ? 'BP Pessoa'
                            : 'mensagens.operacao.formularioPessoa.idPessoa',
                        component: 'el-input',
                        value: '',
                        section: 'outros',
                        fullWidth: true,
                        bind: {
                            maxlength: 200,
                            placeholder: this.isAlvorada
                                ? 'BP Pessoa'
                                : 'mensagens.operacao.formularioPessoa.idPessoa'
                        }
                    }
                ],
                ar: [
                    {
                        key: 'email',
                        label: 'mensagens.comuns.email',
                        component: 'el-input',
                        value: '',
                        section: 'contato',
                        rules: [
                            {
                                type: 'email',
                                message: this.$t(
                                    'mensagens.pessoas.emailInvalido'
                                ),
                                trigger: ['blur', 'change']
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.comuns.email'
                        }
                    },
                    {
                        key: 'telefone',
                        label: 'mensagens.pessoas.telefone',
                        component: 'el-input',
                        value: '',
                        section: 'contato',
                        bind: {
                            placeholder: 'mensagens.comuns.telefone',
                            mask: true
                        }
                    },
                    // {
                    //     key: 'endereco',
                    //     label: 'mensagens.pessoas.endereco',
                    //     component: 'el-input',
                    //     value: '',
                    //     bind: {
                    //         placeholder: 'mensagens.pessoas.endereco'
                    //     }
                    // },
                    {
                        key: 'estado',
                        label: 'mensagens.pessoas.estadoAr',
                        component: 'el-select',
                        value: '',
                        options: [],
                        section: 'localizacao',
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.estadoAr',
                            valueKey: 'code'
                        }
                    },
                    {
                        key: 'municipio',
                        label: 'mensagens.pessoas.municipioAr',
                        component: 'el-select',
                        value: '',
                        options: [],
                        section: 'localizacao',
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.municipioAr',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'localidade',
                        label: 'mensagens.pessoas.tabela.localidade',
                        component: 'el-select',
                        value: '',
                        options: [],
                        section: 'localizacao',
                        fullWidth: true,
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.tabela.localidade',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'id',
                        label: 'mensagens.operacao.formularioPessoa.idPessoa',
                        component: 'el-input',
                        value: '',
                        section: 'outros',
                        fullWidth: true,
                        bind: {
                            maxlength: 200,
                            placeholder:
                                'mensagens.operacao.formularioPessoa.idPessoa'
                        }
                    }
                ]
            },

            formSave: []
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada']),
        locale() {
            return this.usuarioLogado.ambienteLogado !== ''
                ? this.usuarioLogado.ambienteLogado.toLowerCase()
                : 'br';
        },
        formulario() {
            const { base, ar, py, br } = this.form;
            const country = this.usuarioLogado.ambienteLogado;

            let formBase = base;
            switch (country) {
                case 'AR':
                    formBase[2].bind.placeholder = 'mensagens.pessoas.cuit';
                    formBase[2].label = this.$t('mensagens.pessoas.cuit');
                    let arForm = [...ar];

                    if (this.isSucursal) {
                        arForm.unshift({
                            key: 'sucursal',
                            label: 'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.sucursal',
                            component: 'el-select',
                            value: '',
                            options: [],
                            section: 'localizacao',
                            fullWidth: true,
                            rules: {
                                required: true,
                                message: this.$t(
                                    'mensagens.comuns.campoObrigatorio'
                                ),
                                trigger: 'blur'
                            },
                            bind: {
                                placeholder: 'mensagens.comuns.selecione',
                                clearable: true,
                                filterable: true,
                                valueKey: 'code'
                            }
                        });
                    }

                    return { form: [...formBase, ...arForm] };

                case 'PY':
                    formBase[2].bind.placeholder = this.$t(
                        'mensagens.comuns.ruc'
                    );
                    formBase[2].label = this.$t('mensagens.pessoas.ruc');
                    return { form: [...formBase, ...py] };

                default:
                    formBase[2].bind.placeholder =
                        'mensagens.pessoas.numeroCpfCnpj';
                    return { form: [...formBase, ...br] };
            }
        },

        secoesFormulario() {
            const secoesOrdem = [
                'identificacao',
                'contato',
                'localizacao',
                'outros'
            ];

            return secoesOrdem
                .map(secao => ({
                    key: secao,
                    label: `mensagens.pessoas.secao${
                        secao.charAt(0).toUpperCase() + secao.slice(1)
                    }`,
                    campos: this.formulario.form
                        .filter(item => (item.section || 'outros') === secao)
                        .sort((a, b) => (a.fullWidth ? 1 : 0) - (b.fullWidth ? 1 : 0))
                }))
                .filter(secaoItem => secaoItem.campos.length > 0);
        }
    },

    watch: {
        dadosRepresentante: {
            immediate: true,
            handler(person) {
                if (
                    !this.editar ||
                    !person ||
                    Object.keys(person).length === 0
                ) {
                    return;
                }

                this.populateBaseFields(person);
                this.populateCountrySpecificFields(person);
                this.loadLocalidadesIfNeeded(person);
            }
        },
        formulario: {
            deep: true,
            handler({ form }) {
                this.formSave = form;
            }
        },
        'usuarioLogado.ambienteLogado': {
            immediate: true,
            handler(ambiente) {

                if (ambiente !== 'BR') {
                    this.listarLocalidadeNivelUm();
                }

                if (this.editar) return;
                this.form.base[0].value = this.paises.find(
                    item => item.code === ambiente
                )?.label
                    ? this.paises.find(item => item.code === ambiente)?.label
                    : 'Brasil';
            }
        },
        isSucursal: {
            immediate: true,
            handler(value) {
                if (value && this.locale === 'ar') {
                    this.listarSucursais();
                }
            }
        }
    },
    methods: {
        ...mapActions(['setRepresentante', 'removeRepresentante']),

        populateBaseFields(person) {
            const {
                nomeRazaoSocial,
                documentoDecrypt,
                email,
                siglaOrigemAmbiente
            } = person;

            const pais = this.paises.find(
                item => item.code === siglaOrigemAmbiente
            );
            this.form.base[0].value = pais?.label || 'Brasil';
            this.form.base[1].value = nomeRazaoSocial;
            this.form.base[2].value =
                siglaOrigemAmbiente === 'AR'
                    ? this.formatCuit(documentoDecrypt)
                    : documentoDecrypt;

            const emailField = this.form[siglaOrigemAmbiente.toLowerCase()].find(f => f.key === 'email');
            if (emailField) emailField.value = email;
        },

        populateCountrySpecificFields(person) {
            const { siglaOrigemAmbiente } = person;

            const populators = {
                AR: () => this.populateArFields(person),
                PY: () => this.populatePyFields(person),
                BR: () => this.populateBrFields(person)
            };

            const populator =
                populators[siglaOrigemAmbiente] || populators['BR'];
            populator();
        },

        populateArFields(person) {
            const {
                telefono,
                localidadeNivelUm,
                localidadeNivelDois,
                localidadeNivelTres,
                idCliente,
                sucursal
            } = person;

            const fields = [
                telefono,
                localidadeNivelUm,
                localidadeNivelDois,
                localidadeNivelTres,
                idCliente
            ];

            if (this.isSucursal && sucursal !== undefined) {
                const sucursalField = this.formulario.form.find(
                    field => field.key === 'sucursal'
                );
                if (sucursalField) {
                    sucursalField.value = sucursal;
                }
            }
            this.setFormValues(fields);
        },

        populatePyFields(person) {
            const {
                telefono,
                direccion,
                localidadeNivelUm,
                localidadeNivelDois,
                idCliente
            } = person;

            const fields = [
                telefono,
                direccion,
                localidadeNivelUm,
                localidadeNivelDois,
                idCliente
            ];
            this.setFormValues(fields);
        },

        populateBrFields(person) {
            const { idCliente } = person;
            this.setFormValues([idCliente]);
        },

        setFormValues(values) {
            values.forEach((value, index) => {
                if (this.form[this.locale][index] && value !== undefined) {
                    this.form[this.locale][index].value = value;
                }
            });
        },

        loadLocalidadesIfNeeded(person) {
            const {
                siglaOrigemAmbiente,
                localidadeNivelUm,
                localidadeNivelDois
            } = person;

            if (siglaOrigemAmbiente === 'BR') return;

            if (localidadeNivelUm) {
                this.listarLocalidadeNivelDois(Number(localidadeNivelUm));
            }

            if (siglaOrigemAmbiente === 'AR' && localidadeNivelDois) {
                this.listarLocalidadeNivelTres(Number(localidadeNivelDois));
            }
        },

        updateMask(item) {
            if (!item.bind.mask) return;

            item.value = item.value.toUpperCase();

            this.inputMask[item.key] = this.masksDocuments(item.key, item.bind.mask, item.value);
        },

        masksDocuments(key, mask, value) {
            if (key === 'documento') {
                switch (this.locale) {
                    case 'ar':
                        return '##-########-#';
                    case 'py':
                        const _regexAdjust = /\D/gi;
                        const adjustedRuc = value.replace(_regexAdjust, '');
                        return adjustedRuc.length > 8
                            ? '########-#'
                            : adjustedRuc.length < 8
                                ? '######-#'
                                : '#######-#';
                    default:
                        return value.length <= 14
                            ? 'XXX.XXX.XXX-XX'
                            : 'XX.XXX.XXX/XXXX-##';
                }
            } else if (key === 'telefone') {
                switch (this.locale) {
                    case 'ar':
                        return value.length <= 12
                            ? '## ####-####'
                            : '# ## ####-####';
                    case 'py':
                        return value.length <= 10
                            ? '## ### ###'
                            : '### ### ###';
                    default:
                        return '## ##### ####';
                }
            } else {
                return mask || '';
            }
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        atualizarListaRepresentantes() {
            this.$emit('atualizarListaRepresentantes');
        },

        fechar() {
            this.form.base = this.form.base.map((item, index) => {
                if (index > 0) {
                    return { ...item, value: '' };
                } else {
                    return { ...item };
                }
            });

            this.form[this.locale] = this.form[this.locale].map(item => {
                return { ...item, value: '' };
            });

            this.$emit('fechar');
        },

        async salvar(formName) {
            try {
                const isValid = await this.validateForm(formName);
                if (!isValid) return false;

                const params = this.buildParamsBasedOnLocale();

                if (this.editar) {
                    await this.editarRepresentante(params);
                } else {
                    await this.cadastrarRepresentante(params);
                }
            } catch (error) {
                this.handleSalvarError(error);
            }
        },

        validateForm(formName) {
            return new Promise(resolve => {
                this.$refs[formName].validate(valid => {
                    resolve(valid);
                });
            });
        },

        buildParamsBasedOnLocale() {
            const paramsBuilders = {
                py: () => this.buildParamsPy(),
                ar: () => this.buildParamsAr(),
                br: () => this.buildParamsBr()
            };

            const builder = paramsBuilders[this.locale] || paramsBuilders.br;
            return builder();
        },

        buildParamsPy() {
            const fieldMap = this.formSave.reduce((map, field) => {
                map[field.key] = field.value;
                return map;
            }, {});

            return {
                nomeRazaoSocial: fieldMap.nome,
                documento: formatters.removerPontuacaoDocumento(
                    fieldMap.documento
                ),
                email: fieldMap.email,
                telefono: fieldMap.telefone,
                localidadeNivelUm: fieldMap.estado,
                localidadeNivelDois: fieldMap.municipio,
                idCliente: fieldMap.id,
                direccion: fieldMap.endereco,
                tipoDocumento: 2
            };
        },

        buildParamsAr() {
            const fieldMap = this.formSave.reduce((map, field) => {
                map[field.key] = field.value;
                return map;
            }, {});

            const params = {
                nomeRazaoSocial: fieldMap.nome,
                documento: formatters.removerPontuacaoDocumento(
                    fieldMap.documento
                ),
                email: fieldMap.email,
                telefono: fieldMap.telefone,
                localidadeNivelUm: fieldMap.estado,
                localidadeNivelDois: fieldMap.municipio,
                localidadeNivelTres: fieldMap.localidade,
                idCliente: fieldMap.id,
                tipoDocumento: 3
            };

            if (this.isSucursal) {
                params.idSucursal = [String(fieldMap.sucursal)];
            }

            return params;
        },

        buildParamsBr() {
            const fieldMap = this.formSave.reduce((map, field) => {
                map[field.key] = field.value;
                return map;
            }, {});

            return {
                nomeRazaoSocial: fieldMap.nome,
                cpfCnpj: formatters.cpfCnpjFormatToNumeral(fieldMap.documento),
                email: fieldMap.email,
                idCliente: fieldMap.id || this.getLastFormValue(),
                idTipoDocumento: 1
            };
        },

        getLastFormValue() {
            return this.formSave[this.formSave.length - 1]?.value;
        },

        handleSalvarError(error) {
            this.$notify.error({
                message: error.response?.data?.message
            });
        },

        redirecionarTerritorio() {
            this.mostrarModalRedirecionamentoTerritorio = true;
        },

        async editarRepresentante(params) {
            try {
                const serviceStrategies = {
                    br: payload =>
                        RepresentanteService.editarRepresentante(payload),
                    py: payload =>
                        RepresentanteService.editarRepresentantePy(payload),
                    ar_sucursal: payload =>
                        SucursaleService.editarRepresentante(payload),
                    ar_default: payload =>
                        RepresentanteService.editarRepresentanteAr(payload)
                };

                const payload = {
                    id: this.dadosRepresentante.id,
                    ...params
                };

                const getServiceKey = () => {
                    if (this.locale === 'br') return 'br';
                    if (this.locale === 'py') return 'py';
                    if (this.locale === 'ar' && this.isSucursal) {
                        return 'ar_sucursal';
                    }
                    return 'ar_default';
                };

                const serviceKey = getServiceKey();
                const serviceCall = serviceStrategies[serviceKey];

                await serviceCall(payload);

                this.handleEdicaoSucesso();
            } catch (error) {
                this.handleEdicaoError(error);
            }
        },

        handleEdicaoSucesso() {
            this.fechar();
            this.atualizarListaRepresentantes();

            this.$notify.success({
                message: this.$t('mensagens.pessoas.pessoaEditadaComSucesso')
            });
        },

        handleEdicaoError(error) {
            this.$notify.error({
                message: error.response?.data?.message
            });
        },

        formatCuit(cuit) {
            if (cuit.length !== 11) {
                this.$t('mensagens.pessoas.cuitErro');
            }

            return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10)}`;
        },

        async cadastrarRepresentante(params) {
            try {
                const serviceStrategies = {
                    br: () =>
                        RepresentanteService.cadastrarRepresentante(params),
                    py: () =>
                        RepresentanteService.cadastrarRepresentantePy(params),
                    ar_sucursal: () =>
                        SucursaleService.cadastrarRepresentante(params),
                    ar_default: () =>
                        RepresentanteService.cadastrarRepresentanteAr(params)
                };

                const getServiceKey = () => {
                    if (this.locale === 'br') return 'br';
                    if (this.locale === 'py') return 'py';
                    if (this.locale === 'ar' && this.isSucursal) {
                        return 'ar_sucursal';
                    }
                    return 'ar_default';
                };

                const serviceKey = getServiceKey();
                const serviceCall = serviceStrategies[serviceKey];

                const { data } = await serviceCall();

                this.setRepresentante(data);
                this.fechar();
                this.atualizarListaRepresentantes();

                this.$notify.success({
                    message: this.$t(
                        'mensagens.pessoas.pessoaAdicionadaComSucesso'
                    )
                });

                this.redirecionarTerritorio();
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        },

        fecharModalAtalhoTerritorio() {
            this.removeRepresentante();
            this.mostrarModalRedirecionamentoTerritorio = false;
        },

        updateCity(key) {
            if (key !== 'estado' && key !== 'municipio') return;

            const indexEstado = this.form[this.locale].findIndex(
                item => item.key === 'estado'
            );
            const indexCidade = this.form[this.locale].findIndex(
                item => item.key === 'municipio'
            );
            const indexLocalidade = this.form[this.locale].findIndex(
                item => item.key === 'localidade'
            );

            if (indexCidade !== -1 && key === 'estado') {
                this.form[this.locale][indexCidade].value = '';
            }
            if (indexLocalidade !== -1) {
                this.form[this.locale][indexLocalidade].value = '';
            }

            let value = null;
            if (key === 'estado' && indexEstado !== -1) {
                value = this.form[this.locale][indexEstado].value;
            } else if (key === 'municipio' && indexCidade !== -1) {
                value = this.form[this.locale][indexCidade].value;
            }

            if (!value) return;

            if (key === 'estado') {
                this.listarLocalidadeNivelDois(value);
            } else if (key === 'municipio' && indexLocalidade !== -1) {
                this.listarLocalidadeNivelTres(value);
            }
        },

        async listarSucursais() {
            try {
                this.carregandoSucursais = true;
                const { data } = await SucursaleService.listagem();

                const dataFormat = data.sucursais
                    .map(item => {
                        return { label: item.nome, code: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                if (this.isSucursal && this.locale === 'ar') {
                    const sucursalField = this.formulario.form.find(
                        item => item.key === 'sucursal'
                    );
                    if (sucursalField) {
                        sucursalField.options = dataFormat;
                    }
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.sistema.erroInformacoes')
                });
            } finally {
                this.carregandoSucursais = false;
            }
        },

        async listarLocalidadeNivelUm() {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();

                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, code: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                if (this.locale !== 'br') {
                    const index = this.form[this.locale].findIndex(
                        item => item.key === 'estado'
                    );
                    this.form[this.locale][index].options = dataFormat;
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            }
        },

        async listarLocalidadeNivelDois(id) {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(id);
                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, code: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                const index = this.form[this.locale].findIndex(
                    item => item.key === 'municipio'
                );
                this.form[this.locale][index].options = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        async listarLocalidadeNivelTres(id) {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelTres(id);
                const dataFormat = data.map(item => {
                    return { label: item.nome, code: item.id };
                });
                const index = this.form[this.locale].findIndex(
                    item => item.key === 'localidade'
                );
                this.form[this.locale][index].options = dataFormat.sort();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },
        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        }
    }
};
</script>

<style lang="scss">
#modal-editar-cadastrar-representante {
    .scroll-wrapper {
        max-height: 70vh; // ajuste conforme necessário
        overflow-y: auto;
        padding-right: 12px; // previne corte de scrollbar no conteúdo
    }

    .form-secao {
        margin-bottom: 16px;

        &__titulo {
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            color: var(--gray-600, #6b7280);
            margin: 0 0 8px;
            padding-bottom: 4px;
            border-bottom: 1px solid var(--gray-200, #e5e7eb);
        }

        &__grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 0 12px;
        }

        .el-form-item {
            margin-bottom: 12px;
        }
    }

    .form-secao__campo--full {
        grid-column: 1 / -1;
    }

    footer {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
    }

    .invalido {
        color: var(--danger);
    }

    .espaco {
        display: flex;
    }

    .el-form-item .el-form-item__label {
        font-weight: normal !important;
    }
}
</style>
